export function MultipleRoundTripperIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="24" cy="24" r="16" />
      <path d="M24 8v6M24 34v6M8 24h6M34 24h6" />
      <path d="M12 12l4 4M32 32l4 4M32 12l-4 4M12 32l4-4" />
      <circle cx="24" cy="24" r="4" fill="currentColor" />
      <path d="M20 24h8" />
    </svg>
  );
}
